export type TextForms = [string, string, string];

export const numericFormat = (value: number, words: TextForms) => {
  const last2digit = Math.abs(value) % 100;
  const lastDigit = last2digit % 10;
  if (last2digit > 10 && last2digit < 20) {
    return words[2];
  }
  if (lastDigit > 1 && lastDigit < 5) {
    return words[1];
  }
  if (lastDigit === 1) {
    return words[0];
  }

  return words[2];
};
